import { $authHost } from ".";

class StorageApi {
  async getStorage(serverId, signal) {
    const { data } = await $authHost.get(
      `/evrima/storage?serverId=${serverId}`,
      {
        signal,
      }
    );
    return data;
  }
}

const storageApi = new StorageApi();
export default storageApi;
